module.exports = __webpack_public_path__ + "img/百度---360_04.4a97a5f4.jpg";